"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization/");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var CaptionPath_1 = require("./CaptionPath");
var Header_styles_1 = require("./Header.styles");
exports.default = (function () {
    var _a = React.useContext(SearchableNestedDropdown_context_1.SndContext), IsDisabled = _a.IsDisabled, Value = _a.Value, ClearControl = _a.ClearControl, OpenDropdown = _a.OpenDropdown;
    var handleOnClearControlClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        ClearControl();
    };
    var handleOnOpenClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OpenDropdown();
    };
    return (React.createElement(Header_styles_1.ClosedHeader, null,
        React.createElement(Header_styles_1.HeaderCaption, { onClick: handleOnOpenClick },
            React.createElement(CaptionPath_1.default, __assign({}, Value))),
        React.createElement(Header_styles_1.HeaderButton, { "aria-label": Localization_1.strings.SND_Label_Clear, disabled: IsDisabled, onClick: handleOnClearControlClick, title: !IsDisabled ? Localization_1.strings.SND_Label_Clear : undefined, type: "button" },
            React.createElement(Icons_1.CloseThinIcon, null))));
});
